import React from 'react'
import styled from 'styled-components'

const Status = () => {
  return (
    <Wrapper>
      <a name="finished" />
      <h3 id="construction">Construction Phase</h3>
      <p>Construction</p>
      <p>
        Construction has begun{' '}
        <span className="strikethrough">November 2021</span>
        <i className="strikethrough">after January 2022</i> Mars 2022
      </p>

      <h3 id="planning">Planning Phase</h3>
      <p className="done">Finalize contract for Land</p>
      <p className="done">Sign Loan</p>
      <p className="done">Waiting for building permit</p>
      <p className="done">Demand building permit</p>
      <p className="done">Sign Contract for Land</p>
      <p>
        Done online in 30 minutes. Both notaries present via video conference.
      </p>
      <p className="done">Sign Contract for Construction (MCA)</p>
      <p>
        Received by mail, signed with video conference. Simple, efficient. All
        good so far, thank you MCA!
      </p>
      <p className="done">Plan House (March 2021)</p>
      <p>
        After a few iterations, the floor plan is ready. The house got bigger
        and bigger from version to version bigger and bigger. Now it has 4
        rooms, about 130sqm and many big windows. An overhanging roof on all
        sides, water insulation of the foundation, a tarpaulin against moisture
        and penetrating salt from the sea air. With terrace, without garage.
      </p>
      <p className="done">Find Land (February 2021)</p>
      <p>
        The property is found. A few minutes from the beach, quietly located On
        the edge of the forest. Bonus: not a swamp.
      </p>
    </Wrapper>
  )
}

export default Status

const Wrapper = styled.article`
  text-align: center;
  margin: 0 1rem 2rem 1rem;

  .todo {
    color: #ccc;
    font-size: 1.2em;
  }

  .now {
    color: 333;
    font-weight: bold;
    font-size: 1.5em;
  }

  .done {
    font-style: italic;
  }
`
